<template>
  <div class="btnWrapper">
    <transition name="spinner">
      <div class="btnSpinner" :class="{'alertSpinner': type && type === 'alert'}" v-if="state"></div>
    </transition>
    <button
      @click="$emit('clicked')"
      :disabled="disabled"
      ref="btn"
      :class="{'spinnerOn': state, 'alert': type && type === 'alert', 'disabled': disabled}"
    >{{(state === false) ? text : waitText}}</button>
  </div>
</template>

<script>
export default {
  name: "SpinnerBtn",
  props: ["text", "waitText", "state", "type", "btn-class", 'disabled'],
  data() {
    return {};
  },
  created() {
    if (!this.waitText) this.waitText = "אנא המתן";
  },
  mounted() {
    if (this.btnClass && this.btnClass.length > 0) {
      this.$refs.btn.classList += this.btnClass;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/css/style.less";

.spinner-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.spinner-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.spinner-enter,
.spinner-leave-to {
  margin-left: -15px;
  opacity: 0;
}

.btnWrapper {
  padding: 15px 10px !important;
  min-width: max-content;
  width: 200px;
  position: relative;
  display: inline-block;
}

.blueButton {
  padding: 15px 10px !important;
  min-width: max-content;
  width: 200px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
  color: @orange;
  background: @white !important;
  border-radius: 0px !important;
  text-align: center;
  border: 0;
  outline: 0;
  font-size: 17px;
  line-height: 7px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  box-shadow: 1px 1px 3px 0 rgba(15, 15, 15, 0.15),
    -1px -1px 3px 0 rgba(255, 255, 255, 0.15);
  text-shadow: darken(@white, 2%);

  &:hover {
    background: lighten(rgb(224, 220, 220), 6%) !important;
  }

  &:active {
    box-shadow: inset 1px 1px 3px 0 rgba(15, 15, 15, 0.15),
      inset -1px -1px 3px 0 rgba(255, 255, 255, 0.15);
    background: darken(@white, 5%) !important;
  }
}

.btnSpinner {
  z-index: 8;
  position: absolute;
  left: 15px;
  top: 5px;
  font-size: 10px;
  text-indent: -9999em;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  background: -moz-linear-gradient(left, #fff 10%, rgba(255, 255, 255, 0) 42%);
  background: -webkit-linear-gradient(
    left,
    #fff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #fff 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(left, #fff 10%, rgba(255, 255, 255, 0) 42%);
  background: linear-gradient(to right, #fff 10%, rgba(255, 255, 255, 0) 42%);
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.btnSpinner:before {
  width: 50%;
  height: 50%;
  background: #fff;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}

.btnSpinner:after {
  background: @orange;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.alertSpinner:after {
  background: @red;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.spinnerOn {
  box-shadow: 0px 0px 335px 957px rgba(15, 15, 15, 0.65);
  padding: 13px 8px 13px 45px;
  color: lighten(#ff6500, 30%) !important;
}

.buttonStyle(@color) {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
  color: @white;
  background: @color !important;
  border-radius: 0px !important;
  padding: 15px 10px !important;
  min-width: max-content;
  width: 200px;
  text-align: center;
  border: 0;
  outline: 0;
  font-size: 17px;
  line-height: 7px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  box-shadow: 1px 1px 3px 0 rgba(15, 15, 15, 0.15),
    -1px -1px 3px 0 rgba(255, 255, 255, 0.15);
  text-shadow: darken(@color, 2%);

  &:hover {
    background: lighten(@color, 5%) !important;
  }

  &:active {
    box-shadow: inset 1px 1px 3px 0 rgba(15, 15, 15, 0.15),
      inset -1px -1px 3px 0 rgba(255, 255, 255, 0.15);
    background: darken(@color, 5%) !important;
  }
}

button {
  .buttonStyle(@orange);
}

.alert {
  .buttonStyle(@red);
}
.disabled, .disabled:hover{
  cursor: not-allowed;
  background-color: @grey !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/spinnerBtn.vue